export default __webpack_public_path__ + "static/media/Home-Hero-bg.3f9ba060.jpg";